// Maps browser locale region codes to our supported currencies.
// We support: GBP, USD, EUR, CAD, AUD, INR, NGN
const COUNTRY_TO_CURRENCY = {
  // GBP
  GB: "GBP",
  // USD (we route Americas-without-CAD here)
  US: "USD",
  // EUR (eurozone)
  IE: "EUR", DE: "EUR", FR: "EUR", ES: "EUR", IT: "EUR", NL: "EUR",
  PT: "EUR", AT: "EUR", BE: "EUR", FI: "EUR", GR: "EUR", LU: "EUR",
  CY: "EUR", EE: "EUR", LV: "EUR", LT: "EUR", MT: "EUR", SK: "EUR", SI: "EUR",
  // CAD
  CA: "CAD",
  // AUD (kept tight — NZ falls back to USD via Stripe by default)
  AU: "AUD",
  // INR
  IN: "INR",
  // NGN
  NG: "NGN",
};

const SUPPORTED = ["GBP", "USD", "EUR", "CAD", "AUD", "INR", "NGN"];
const STORAGE_KEY = "studict_currency";

export function detectCurrency() {
  // 1. Honour explicit user choice if previously set
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && SUPPORTED.includes(saved)) return saved;
  } catch (_) { /* ignore */ }

  // 2. Use browser locale e.g. "en-US" -> "USD"
  try {
    const locales = navigator.languages?.length ? navigator.languages : [navigator.language || "en-GB"];
    for (const loc of locales) {
      const region = loc.split("-")[1]?.toUpperCase();
      if (region && COUNTRY_TO_CURRENCY[region]) return COUNTRY_TO_CURRENCY[region];
    }
  } catch (_) { /* ignore */ }

  // 3. Fallback
  return "GBP";
}

export function setCurrency(code) {
  try { localStorage.setItem(STORAGE_KEY, code); } catch (_) { /* ignore */ }
}

export function formatPrice(amount, currency) {
  const value = (amount === null || amount === undefined) ? 0 : Number(amount);
  // Currencies where decimals look ugly at typical price points
  const noDecimals = ["INR", "NGN", "JPY", "KRW"].includes(currency);
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      minimumFractionDigits: noDecimals ? 0 : 2,
      maximumFractionDigits: noDecimals ? 0 : 2,
    }).format(value);
  } catch (_) {
    return `${currency} ${value}`;
  }
}

export const SUPPORTED_CURRENCIES = SUPPORTED;
